/**
 * @file ws-util 模块入口
 * old wsUtil -> ws-util
 */
/* eslint-disable-next-line */
import ajax from './ajax';
import cookie from './cookie';
import dom from './dom';
import html from './html';
import load from './load';
import localstorage from './localstorage';
import string from './string';
import token from './token';
import varType from './type';
import url from './url';

export {
  ajax,
  cookie,
  dom,
  html,
  load,
  localstorage,
  string,
  token,
  varType,
  url,
};

export default {
  ajax,
  cookie,
  dom,
  html,
  load,
  localstorage,
  string,
  token,
  varType,
  url,
};
